export default {
  estaCarregando: false,
  lista: [],
  filtros: {
    tipo_turma: []
  }
}
